import styled, { css, StyledProps } from 'styled-components'
import { EColorBgText, sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import {
  EModClear,
  EModColorBgText,
  IModClear,
  IModColorBgText,
} from '@ucheba/utils/helpers/styles/mod.types'
import { EModChipsVariant, IChipsVariantProps } from '../types'

const Block = styled.div<StyledProps<IModColorBgText & IModClear & IChipsVariantProps>>`
  border-radius: 50px;
  text-align: center;
  padding: ${sv.spacing.usmall} ${sv.spacing.xsmall};
  display: inline-flex;

  ${Object.keys(EModColorBgText).map(
    (item) => sm.mod(EModColorBgText[item])`
      background-color: ${sv.color[item]};
      color: ${sv.color[EColorBgText[item]]};
      border: 1px solid ${sv.color[item]};

      ${
        item === 'blue' &&
        css`
          button {
            background-color: ${sv.color.cobalt} !important;
          }

          svg {
            color: ${sv.color.white};
            opacity: 0.7;
          }
        `
      };

      ${
        (item === 'gray5' || item === 'silver') &&
        css`
          button {
            background-color: ${sv.color.white} !important;
          }

          svg {
            color: ${sv.color.black};
            opacity: 0.7;
          }
        `
      };

      ${sm.mod(EModChipsVariant.outline)`
        background-color: ${sv.color.transparent};
        color: ${sv.color[item]};
        border: 1px solid ${sv.color[`${item}30`]};
      `}
    `
  )};

  ${sm.mod(EModClear.true)`
    padding-right: ${sv.spacing.usmall};

    button {
      margin-left: ${sv.spacing.xxsmall};
    }

    &:hover {
      text-decoration: line-through;

      svg {
        opacity: 1;
      }
    }
  `};
`

export default { Block }
